import type { EnvironmentV2Resource } from "@octopusdeploy/octopus-server-client";
import { ExpandingTagList } from "~/areas/infrastructure/components/ArgoCDInstances/components/ExpandingTagList";
import { environmentV2TagList, environmentV2WithMissingTagList } from "~/components/Tag";
type EnvironmentsTagListProps = {
    environmentIds: string[];
    environments: EnvironmentV2Resource[];
};
export const EnvironmentsTagList = (props: EnvironmentsTagListProps) => <ExpandingTagList singularName={"environment"} ids={props.environmentIds} renderTagList={(ids) => environmentV2TagList(props.environments, ids)}/>;
export const EnvironmentsWithMissingTagList = (props: EnvironmentsTagListProps) => <ExpandingTagList singularName={"environment"} ids={props.environmentIds} renderTagList={(ids) => environmentV2WithMissingTagList(props.environments, ids)}/>;
